import {ProviderDetails} from 'domain/usecases/private/communications/get-communications';
import {formatDetail} from './formatDetail';
import {FormatType} from '../constants/FormatType';

export const formatAddress = (provider: ProviderDetails): string => {
	const {nmLogradouro, nuEndereco, nmEndereco, nmBairro, nmCidade, nmUf, nuCep} = provider;
	const logradouro = nmLogradouro ? `${nmLogradouro}.` : '';

	return [
		logradouro,
		nmEndereco,
		nuEndereco,
		`${nmBairro}`,
		`${nmCidade} - ${nmUf}`,
		formatDetail(nuCep, FormatType.CEP),
	]
		.filter(Boolean)
		.join(', ')
		.replace(/\.,\s/g, '. ')
		.trim();
};
